import React from 'react';

const Step = React.Fragment;
export default Step;
